import AecomLogoPng from '@/assets/images/aecom-logo-black.png';

// Export the logo URL for libraries that can use it directly (like jsPDF)
export { AecomLogoPng };

// Helper to fetch logo image as ArrayBuffer for libraries that need binary data (docx, exceljs)
export const fetchLogoAsArrayBuffer = async (): Promise<ArrayBuffer> => {
  const response = await fetch(AecomLogoPng);
  return response.arrayBuffer();
};
